import { render, staticRenderFns } from "./ViewRole.vue?vue&type=template&id=8e52a500&"
import script from "./ViewRole.vue?vue&type=script&lang=js&"
export * from "./ViewRole.vue?vue&type=script&lang=js&"
import style0 from "./ViewRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports